import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { AuthStore } from '@shared/stores';
import container from '@core/di';
import { Avatar, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Modal from '@shared/components/Modal';
import { AvatarGroup } from '@mui/material';
import AvatarImage from '@public/assets/images/avatar.png';
import history from '@shared/utils/history';
import ROUTES from '@Admin/shared/constants/routes';
import ProfileStore from '@shared/stores/profile';
import { observer } from 'mobx-react';

const useStyles = makeStyles(() => ({
  paper: {
    top: '50px!important',
    minWidth: '200px',
  },
  root: {
    marginRight: '20px',
    '&:hover': {
      borderRadius: 0,
    },
  },
  list: {
    width: '220px',
  },
  buttonRoot: {
    backgroundColor: 'unset',
    boxShadow: 'none',
    border: 'none',
    fontWeight: 500,
    fontSize: 14,
    color: '#cae7ea',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: 'unset',
    },
  },
  endIcon: {
    marginLeft: 49,
  },
  avatar: {
    height: 28,
    width: 28,
  },
  avatarGroup: {
    border: '1px solid #ffffff !important',
  },
}));

interface ProfileMenuProps {}

const ProfileMenu: React.FC<ProfileMenuProps> = observer(() => {
  const classes = useStyles();

  const profileStore = React.useMemo(() => container.get<ProfileStore>(ProfileStore.diToken), []);

  const { profile, profileFetching } = profileStore;

  const [isModalLogoutShown, setIsModalLogoutShown] = React.useState(false);

  const authStore = container.get<AuthStore>(AuthStore.diToken);

  const {
    userProfile: { name },
  } = authStore;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    setIsModalLogoutShown(true);
  };

  const handleOpenProfile = () => {
    handleClose();
    history.push(ROUTES.private.profile);
  };

  const actionLogout = () => {
    localStorage.removeItem('regenerateTreatmentInformation');
    authStore.logout();
  };

  React.useEffect(() => {
    if (!profile && !profileFetching) {
      profileStore.current();
    }
  }, [profile, profileFetching, profileStore]);

  return (
    <div>
      <Button
        variant="contained"
        onClick={handleMenu}
        classes={{
          root: classes.buttonRoot,
          endIcon: classes.endIcon,
        }}
        startIcon={
          <AvatarGroup
            max={2}
            classes={{
              avatar: classes.avatarGroup,
            }}
          >
            <Avatar
              alt="My avatar"
              src={profile?.profileImageUrl || AvatarImage}
              classes={{
                root: classes.avatar,
              }}
            />
          </AvatarGroup>
        }
        endIcon={<ArrowDropDownIcon style={{ color: '#fff' }} />}
      >
        {profile?.firstName && profile?.lastName
          ? `${profile?.firstName} ${profile?.lastName} `
          : name}
      </Button>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        classes={{
          paper: classes.paper,
          list: classes.list,
        }}
        onClose={handleClose}
      >
        <MenuItem onClick={handleOpenProfile}>View my profile</MenuItem>
        <MenuItem onClick={handleLogout}>Log out</MenuItem>
      </Menu>

      <Modal
        isOpen={isModalLogoutShown}
        onClose={() => setIsModalLogoutShown(false)}
        title="Are you sure you want to log out?"
        submitAction={actionLogout}
        submitText="Log out"
      />
    </div>
  );
});

export default ProfileMenu;
